import React from 'react';
import { Link } from 'gatsby';

import {
  Layout,
  SEO,
  HeaderBanner,
  ContactInfo,
  ContactForm,
  JustLanded,
  JustDropped,
  NewsletterSignup,
  GoogleMap,
} from '../components';

function ContactPage() {
  return (
    <Layout>
      <SEO title="Contact" />
      <HeaderBanner
        slot1={
          <Link
            to="/"
            className="focus:shadow-none focus:underline hover:underline"
          >
            &larr; Return home
          </Link>
        }
        heading="Contact Us"
      />
      <div className="grid gap-6">
        <div className="grid w-full max-w-5xl grid-cols-2 px-4 py-12 mx-auto sm:px-6 lg:px-8">
          <ContactInfo />
          <ContactForm />
        </div>
        <JustLanded />
        <JustDropped />
      </div>
      <NewsletterSignup />
      <GoogleMap />
    </Layout>
  );
}

export default ContactPage;
